import React, { memo } from "react";
import { View, Modal, TouchableOpacity } from "react-native";
import color from "@constants/color";
import { width } from "@constants/metrics";
import t from "@constants/localization";
import { DeleteBankAc } from "@constants/strings";
import Text from "@components/CustomText";
import { ScaledSheet } from '@utils/scale';

const defaultButtonText = [
  { text: DeleteBankAc.Delete1, color: DeleteBankAc.primary },
  { text: DeleteBankAc.Cancel, color: DeleteBankAc.white },
];

interface ButtonProps {
  text: string;
  color: string;
}
interface Props {
  type: string;
  heading?: string;
  heading2?: string;
  buttonText?: ButtonProps[];
  PATH: string;
  onPress?: (text: string, index: number) => void;
  visible?: boolean;
  number?: number;
  accountText?: string;
}

const DeletePaymentModeModal = (props: Props) => {
  const {
    type,
    heading,
    heading2,
    buttonText = defaultButtonText,
    PATH,
    onPress,
    visible = true,
    number = 0,
    accountText = "",
  } = props;

  const Title1 =
    type === DeleteBankAc.bank_account
      ? t(`${PATH}/removeBank`)
      : t(`${PATH}/removeUPI`);
  const Title2 =
    type === DeleteBankAc.bank_account
      ? t(`${PATH}/cnfmRemoveBank`, { accountText })
      : t(`${PATH}/cnfmRemoveUPI`, { accountText });

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      visible={visible}
      transparent={true}
    >
      <View style={styles.modalContainer}>
        <View style={styles.modalContent} testID={heading || Title1}>
          <Text variant="subtitle_20" style={styles.headingText}>
            {heading || Title1}
          </Text>
          <Text variant="body_text_3" style={styles.subHeadingText}>
            {heading2 || Title2}
          </Text>
          <View style={styles.buttonContainer}>
            {buttonText.map((item, index) => (
              <TouchableOpacity
                key={`${index}=${item.text}`}
                style={[
                  styles.button,
                  item.color === DeleteBankAc.primary
                    ? styles.primaryButton
                    : styles.whiteButton,
                ]}
                onPress={() => onPress && onPress(item.text, number)}
                testID={`${index}=${item.text}`}
              >
                <Text
                  variant="title_18_semi"
                  style={[
                    item.color === DeleteBankAc.primary
                      ? styles.whiteButtonText
                      : styles.primaryButtonText,
                  ]}
                >
                  {item.text}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = ScaledSheet.create({
  modalContainer: {
    backgroundColor: color.modalBackground,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    width: width - 64,
    backgroundColor: color.white,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
  },
  headingText: {
    color: color.Gray20,
    paddingVertical: 5,
  },
  subHeadingText: {
    color: color.mediumBlacklightBlack,
    textAlign: "center",
    paddingVertical: 5,
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
  },
  button: {
    marginVertical: 12,
    marginHorizontal: 8,
    paddingVertical: 6,
    borderWidth: 1,
    borderRadius: 20,
    flex: 1,
    alignItems: "center",
  },
  primaryButton: {
    borderColor: color.primary,
    backgroundColor: color.primary,
  },
  whiteButton: {
    borderColor: color.primary,
    backgroundColor: color.white,
  },
  primaryButtonText: {
    color: color.primary,
  },
  whiteButtonText: {
    color: color.white,
  },
});

export default memo(DeletePaymentModeModal);
